<template>
  <div>
    <a-button type="primary" icon="plus" @click.prevent="$refs.modal.open">
    </a-button>
    <modal ref="modal" />
  </div>
</template>

<script>
import Modal from './Modal.vue';

export default {
  name: 'item',
  components: { Modal },
};
</script>
